import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ASSET_MODAL_KEYWORD } from "~/constants/testIDs";
export const InfoPanelSummaryKeywordList = /*#__PURE__*/ memo((param)=>{
    let { keywords, onKeywordClick } = param;
    if (!(keywords === null || keywords === void 0 ? void 0 : keywords.length)) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-wrap items-baseline gap-1.5 space-y-2 pb-2",
        children: keywords.map((param)=>{
            let { label, id } = param;
            return /*#__PURE__*/ _jsx("button", {
                className: "h-6 max-w-full shrink-0 items-center truncate break-words rounded-full border border-grey-5 bg-grey-1 px-2 text-12 font-medium text-grey-12",
                "data-testid": "".concat(ASSET_MODAL_KEYWORD, "-").concat(label),
                onClick: onKeywordClick ? ()=>onKeywordClick === null || onKeywordClick === void 0 ? void 0 : onKeywordClick(label) : undefined,
                children: label
            }, id);
        })
    });
});
InfoPanelSummaryKeywordList.displayName = "InfoPanelSummaryKeywordList";
